export const matrizGutHelper = {
  matrizGutColor
}

function matrizGutColor(valor) {
  if (valor >= 0 && valor <= 25) return 'success';
  else if (valor >= 25 && valor < 50) return 'success darken-1';
  else if (valor >= 50 && valor < 75) return 'warning';
  else if (valor >= 75 && valor < 100) return 'warning darken-1';
  else if (valor >= 100 && valor < 125) return 'error';
  else if (valor == 125) return 'error darken-1';
}